import { flagFactory } from '../icon';
import Svg from './bg.svg';

export default flagFactory(Svg);
